// D:\brickbucket_v3.1\Brickbucket_Frontend_V3.1\src\ConsumerApp\Screens\Home\Home.js

import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar, CenteredContainer, Footer } from '../../DesignSystem';
import { theme } from '../../../assets/theme/theme';
import Bucket from '../Bucket/Bucket';

// SVG Icons matching React Native exactly
import ToteIcon from '../../../assets/icons/tote.svg';
import WhatsappLogo from '../../../assets/icons/WhatsApp.svg';
import ArrowRight from '../../../assets/icons/ArrowRight.svg';

// Brand Image Assets matching React Native configuration
import UltratechCementImg from '../../../assets/images/Brands/UltratechCement.jpeg';
import DalmiaCementImg from '../../../assets/images/Brands/DalmiaBarathCement.jpg';
import AsianPaintsImg from '../../../assets/images/Brands/asianPaints.jpg';
import FinolexImg from '../../../assets/images/Brands/Finolex.jpg';
import SupremePlasticsImg from '../../../assets/images/Brands/SupremePlastics.jpg';
import MYKArmentImg from '../../../assets/images/Brands/MYKArment.jpg';
import RRKabel from '../../../assets/images/Brands/RR.png';
import Goldmedal from '../../../assets/images/Brands/Goldmedal.png';
import kcp from '../../../assets/images/Brands/kcp.jfif';
import krafto from '../../../assets/images/Brands/kraftoLogo.png';
import simpolo from '../../../assets/images/Brands/Simpolo.png';
import siemens from '../../../assets/images/Brands/siemens.png';

// Shared API Hooks
import { useGetCategories } from '../../api/categories/category.hooks';
import {
  useGetFeaturedProducts,
  useFrequentlyBoughtProducts,
} from '../../api/products/product.hooks';
import { useGetOrdersByCustomer } from '../../api/orders/orders.hooks';
import LiveOrderTrackerBanner from './components/LiveOrderTrackerBanner';
import BuilderTestimonials from './components/BuilderTestimonials';
import FeaturedCategoriesSection from './components/FeaturedCategoriesSection';

const IMAGE_BASE_URL = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES || 'https://assets.brickbucket.in/';
const BUSINESS_WHATSAPP_NUMBER = '918639065454';

// Popular Brands Data matching Mobile
const POPULAR_BRANDS = [
  { id: '1', name: 'UltraTech', label: 'UltraTech\nCEMENT', image: UltratechCementImg },
  { id: '2', name: 'Dalmia', label: 'Dalmia\ncement', image: DalmiaCementImg },
  { id: '3', name: 'Asian Paints', label: 'ap\nasianpaints', image: AsianPaintsImg },
  { id: '4', name: 'Finolex', label: 'Finolex\nPIPES', image: FinolexImg },
  { id: '5', name: 'Supreme', label: 'Supreme\nPlastics', image: SupremePlasticsImg },
  { id: '6', name: 'MYK Arment', label: 'MYK\narment', image: MYKArmentImg },
  { id: '7', name: 'RR Kabel', label: 'MYK\narment', image: RRKabel },
  { id: '8', name: 'Gold Medal', label: 'MYK\narment', image: Goldmedal },
  { id: '9', name: 'KCP', label: 'MYK\narment', image: kcp },
  { id: '10', name: 'Krafto', label: 'MYK\narment', image: krafto },
  { id: '11', name: 'siemens', label: 'MYK\narment', image: siemens },
  { id: '12', name: 'simpolo', label: 'MYK\narment', image: simpolo },
  
];

function CategoryCardImage({ imageUri }) {
  const [hasError, setHasError] = useState(false);

  if (!imageUri || hasError) {
    return (
      <div style={styles.categoryFallbackBox}>
        <img src={ToteIcon} alt="Category fallback" style={styles.toteIcon28} />
      </div>
    );
  }

  return (
    <img
      src={imageUri}
      alt="Category"
      style={styles.categoryImg}
      onError={() => setHasError(true)}
    />
  );
}

function RecentItemImage({ imageUri }) {
  const [hasError, setHasError] = useState(false);

  if (!imageUri || hasError) {
    return (
      <div style={styles.recentImageFallback}>
        <img src={ToteIcon} alt="Product fallback" style={styles.toteIcon20} />
      </div>
    );
  }

  return (
    <img
      src={imageUri}
      alt="Product"
      style={styles.recentImage}
      onError={() => setHasError(true)}
    />
  );
}

export default function Home() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [isBucketOpen, setIsBucketOpen] = useState(false);

  // Authenticated customer retrieval
  const customer = useMemo(() => {
    try {
      const stored = sessionStorage.getItem('userData') || localStorage.getItem('userData');
      return stored ? JSON.parse(stored) : null;
    } catch (e) {
      return null;
    }
  }, []);

  const customerId = customer?._id;

  // Live Queries
  const { data: rawCategories, isLoading: isCategoriesLoading, isError: isCategoriesError } = useGetCategories();
  const { data: rawMostSearched, isLoading: isProductsLoading } = useFrequentlyBoughtProducts();
  const { data: ordersData } = useGetOrdersByCustomer(customerId);
  const { data: featuredData } = useGetFeaturedProducts();
  console.log(featuredData);

  const categories = useMemo(() => {
    const list = Array.isArray(rawCategories) ? rawCategories : rawCategories?.data || [];
    return list.map((cat) => ({
      id: cat._id || cat.id,
      name: cat.product_category_name || cat.name || '',
      image: cat.product_category_image ? `${IMAGE_BASE_URL}${cat.product_category_image}` : null,
    }));
  }, [rawCategories]);

  const mostBoughtList = useMemo(() => {
    const list = Array.isArray(rawMostSearched) ? rawMostSearched : rawMostSearched?.data || [];
    return list;
  }, [rawMostSearched]);



const featuredCategorySections = useMemo(() => {
  return Array.isArray(featuredData) ? featuredData : featuredData?.data || [];
}, [featuredData]);

  const activeLiveOrders = useMemo(() => {
    const all = ordersData?.orders || ordersData || [];
    if (!Array.isArray(all)) return [];
    const activeStatuses = ['Pending', 'Confirmed', 'Delivering'];
    return all.filter((o) => activeStatuses.includes(o.salesorder_status) || o.is_live_order);
  }, [ordersData]);

  const handleOpenWhatsAppRFQ = () => {
    const message = encodeURIComponent('Hi, I would like to request a quote (RFQ) for my material list.');
    window.open(`https://wa.me/${BUSINESS_WHATSAPP_NUMBER}?text=${message}`, '_blank');
  };

  return (
    <div style={styles.pageShell}>
      {/* Universal Navigation Bar */}
      <Navbar
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
      />

      <main style={styles.mainFeedShell}>
        <CenteredContainer>
          <div style={styles.feedColumn}>

            {/* LIVE ORDER BANNER */}
            {activeLiveOrders && activeLiveOrders.length > 0 && (
              <LiveOrderTrackerBanner activeOrder={activeLiveOrders[0]} />
            )}

            {/* 1. TOP 3-CARD HERO DECK */}
            <div style={styles.heroRow}>
              {/* Card 1: Fast Site Delivery */}
              <div style={styles.heroSlideCard}>
                <div style={styles.heroTextSection}>
                  <span style={styles.heroTagline}>Fast site delivery</span>
                  <h2 style={styles.heroHeading}>30–90 mins</h2>
                  <span style={styles.heroSubtext}>on eligible items</span>
                  <div
                    style={styles.heroLocationRow}
                    onClick={() => navigate('/consumer/account/delivery')}
                  >
                    <span style={styles.heroLocationLink}>📍 Check availability by location</span>
                  </div>
                </div>
                <div style={styles.truckIconPlaceholder}>
                  <span style={styles.truckEmoji}>🚚</span>
                </div>
              </div>

              {/* Card 2: Site Emergency Value-Prop */}
              <div style={styles.heroSlideAltCard}>
                <div style={styles.heroTextSection}>
                  <div style={styles.urgencyBadge}>
                    <span style={styles.urgencyBadgeText}>SITE EMERGENCY</span>
                  </div>
                  <h3 style={styles.heroHeadingAlt}>Running out of small items?</h3>
                  <p style={styles.heroSubtextAlt}>
                    Don't waste petrol and time visiting the market for a ₹125 fitting. We deliver in minutes.
                  </p>
                </div>
                <div style={styles.clockIconPlaceholder}>
                  <span style={styles.clockEmoji}>⚡</span>
                </div>
              </div>

              {/* Card 3: WhatsApp Bulk RFQ Card */}
              <div
                style={styles.heroWhatsAppCard}
                onClick={handleOpenWhatsAppRFQ}
              >
                <div style={styles.heroTextSection}>
                  <div style={styles.whatsappBadge}>
                    <img src={WhatsappLogo} alt="WhatsApp" style={styles.whatsappMiniSvg} />
                    <span style={styles.whatsappBadgeText}>BULK ESTIMATES</span>
                  </div>
                  <h3 style={styles.heroHeadingAlt}>Got bulk requirement?</h3>
                  <p style={styles.heroSubtextAlt}>
                    Share your material list on WhatsApp. Receive verified quotes directly on your phone.
                  </p>
                  <div style={styles.heroLocationRow}>
                    <span style={styles.heroLocationLinkGreen}>Request for Quote →</span>
                  </div>
                </div>
                <div style={styles.whatsappIconPlaceholder}>
                  <img src={WhatsappLogo} alt="WhatsApp" style={styles.whatsappHeroSvg} />
                </div>
              </div>
            </div>

            {/* 2. BROWSE BY CATEGORY */}
            <section style={styles.sectionContainer}>
              <div style={styles.sectionHeaderRow}>
                <h3 style={styles.sectionTitle}>Browse by Category</h3>
              </div>

              {isCategoriesLoading ? (
                <div style={styles.stateContainer}>Loading categories...</div>
              ) : isCategoriesError ? (
                <div style={styles.errorText}>Failed to load categories.</div>
              ) : (
                <div style={styles.categoriesGrid}>
                  {categories.map((item) => (
                    <div
                      key={item.id}
                      style={styles.categoryItemCard}
                      onClick={() =>
                        navigate('/consumer/productslist', {
                          state: { categoryId: item.id, categoryName: item.name },
                        })
                      }
                    >
                      <div style={styles.categoryImgBox}>
                        <CategoryCardImage imageUri={item.image} />
                      </div>
                      <span style={styles.categoryItemName} title={item.name}>
                        {item.name}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </section>

            {/* 3. OFFERS FOR YOU */}
            <section style={styles.sectionContainer}>
              <div style={styles.sectionHeaderRow}>
                <h3 style={styles.sectionTitle}>Offers for You</h3>
                <div
                  style={styles.viewAllBtn}
                  onClick={() => navigate('/consumer/account/offers')}
                >
                  <span style={styles.viewAllText}>View All</span>
                  <img src={ArrowRight} alt="Arrow" style={styles.arrowIcon} />
                </div>
              </div>

              <div style={styles.discountsRow}>
                <div
                  style={{ ...styles.discountCard, ...styles.couponCardBg }}
                  onClick={() => navigate('/consumer/account/offers')}
                >
                  <div style={styles.discountIconBadgeRed}>
                    <span style={styles.percentText}>%</span>
                  </div>
                  <div style={styles.discountCardTextGroup}>
                    <span style={styles.couponCodeTitle}>FIRSTFOUR</span>
                    <span style={styles.discountDesc}>₹100 off on your first 4 orders</span>
                    <span style={styles.discountMinOrder}>Min. order ₹999</span>
                  </div>
                  <img src={ArrowRight} alt="Arrow" style={styles.arrowIcon14} />
                </div>

                <div
                  style={{ ...styles.discountCard, ...styles.referralCardBg }}
                  onClick={() => navigate('/consumer/account/wallet')}
                >
                  <div style={styles.discountIconBadgeGreen}>
                    <span style={styles.referralIconText}>👥</span>
                  </div>
                  <div style={styles.discountCardTextGroup}>
                    <span style={styles.referralTitle}>Refer & Save</span>
                    <span style={styles.discountDesc}>You and your referral get ₹100 each</span>
                  </div>
                  <img src={ArrowRight} alt="Arrow" style={styles.arrowIcon14} />
                </div>
              </div>
            </section>

{/* 4. FREQUENTLY BOUGHT BY BUYERS */}
{!isProductsLoading && mostBoughtList.length > 0 && (
  <section style={styles.sectionContainer}>
    {/* Scoped CSS for single-row horizontal carousel across all screen sizes */}
    <style>{`
      .frequently-bought-wrapper {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
      }

      .frequently-bought-container {
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;
        gap: 20px;
        width: 100%;
        padding: 4px 2px 14px 2px;
        scroll-behavior: smooth;
        scrollbar-width: none;
        -webkit-overflow-scrolling: touch;
        scroll-snap-type: x mandatory;
      }

      .frequently-bought-container::-webkit-scrollbar {
        display: none;
      }

      .frequently-bought-card {
        width: 160px;
        min-width: 160px;
        background-color: #FFFFFF;
        border-radius: 12px;
        border: 0.5px solid #CBD5E1;
        overflow: hidden;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        scroll-snap-align: start;
        transition: transform 0.15s ease, box-shadow 0.15s ease;
        box-sizing: border-box;
      }

      .frequently-bought-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
      }

      .carousel-nav-btn {
        position: absolute;
        top: calc(50% - 10px);
        transform: translateY(-50%);
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-color: #FFFFFF;
        border: 1px solid #E2E8F0;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 10;
        transition: background-color 0.15s ease, transform 0.15s ease;
      }

      .carousel-nav-btn:hover {
        background-color: #F8FAFC;
        transform: translateY(-50%) scale(1.05);
      }

      .carousel-nav-prev {
        left: -14px;
      }

      .carousel-nav-next {
        right: -14px;
      }

      @media (max-width: 768px) {
        .frequently-bought-container {
          gap: 16px;
          padding-bottom: 8px;
        }
        .frequently-bought-card {
          width: 142px;
          min-width: 142px;
        }
        .carousel-nav-btn {
          display: none; /* Hide arrows on touch devices in favor of natural swipe */
        }
      }

      @media (max-width: 480px) {
        .frequently-bought-container {
          gap: 14px;
        }
        .frequently-bought-card {
          width: 138px;
          min-width: 138px;
        }
      }
    `}</style>

    <div style={styles.sectionHeaderRow}>
      <h3 style={styles.sectionTitle}>Frequently bought by buyers</h3>
    </div>

    <div className="frequently-bought-wrapper">
      {/* Desktop SVG Left Chevron Button */}
      <button
        className="carousel-nav-btn carousel-nav-prev"
        type="button"
        aria-label="Scroll left"
        onClick={() => {
          const container = document.getElementById('frequently-bought-scroll');
          if (container) container.scrollBy({ left: -340, behavior: 'smooth' });
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2B2A29" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>

      {/* Single-Row Horizontal Scroll Container */}
      <div id="frequently-bought-scroll" className="frequently-bought-container">
        {mostBoughtList.map((item) => {
          const productId = item.product_id || item._id;
          const name = item.product_name || item.name || 'Unknown Product';
          const imgPath = item.product_image || item.product_image_url || item.image;
          const buyNowPrice =
            item?.buy_now?.unit_price ||
            item?.selling_price ||
            item?.unit_price ||
            item?.price;
          const mrp = item?.mrp;

          return (
            <div
              key={productId}
              className="frequently-bought-card"
              onClick={() =>
                navigate('/consumer/productdetails', { state: { productId } })
              }
            >
              <RecentItemImage
                imageUri={imgPath ? `${IMAGE_BASE_URL}${imgPath}` : null}
              />

              <div style={styles.productCardBody}>
                <p style={styles.productName} title={name}>
                  {name}
                </p>

                <div style={styles.priceRow}>
                  <span style={styles.productPrice}>₹{Number(buyNowPrice).toLocaleString('en-IN')}</span>
                  {mrp && Number(mrp) > Number(buyNowPrice) && (
                    <span style={styles.productMrp}>₹{Number(mrp).toLocaleString('en-IN')}</span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Desktop SVG Right Chevron Button */}
      <button
        className="carousel-nav-btn carousel-nav-next"
        type="button"
        aria-label="Scroll right"
        onClick={() => {
          const container = document.getElementById('frequently-bought-scroll');
          if (container) container.scrollBy({ left: 340, behavior: 'smooth' });
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2B2A29" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>
    </div>
  </section>
)}

{/* FEATURED CATEGORY PRODUCTS REUSING ProductCard */}
{featuredCategorySections.length > 0 && (
  <FeaturedCategoriesSection categorySections={featuredCategorySections} />
)}

            {/* 5. OUR TRUSTED BRANDS */}
        <section style={styles.sectionContainer}>
  {/* Scoped CSS for Continuous Auto-Scroll & Interactive Pause */}
  <style>{`
    .brands-marquee-viewport {
      width: 100%;
      overflow: hidden;
      position: relative;
      padding: 10px 0 16px 0;
      /* Subtle edge-fade mask for premium quick-commerce finish */
      mask-image: linear-gradient(to right, transparent, #000000 5%, #000000 95%, transparent);
      -webkit-mask-image: linear-gradient(to right, transparent, #000000 5%, #000000 95%, transparent);
    }

    .brands-marquee-track {
      display: flex;
      align-items: center;
      gap: 16px;
      width: max-content;
      animation: continuousScroll 28s linear infinite;
      will-change: transform;
    }

    /* Pause scrolling when user hovers to click */
    .brands-marquee-viewport:hover .brands-marquee-track {
      animation-play-state: paused;
    }

    @keyframes continuousScroll {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-50%);
      }
    }

    .brand-logo-card {
      width: 124px;
      min-width: 124px;
      height: 78px;
      background-color: #FFFFFF;
      border-radius: 12px;
      border: 1px solid #E2E8F0;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 14px;
      cursor: pointer;
      flex-shrink: 0;
      box-sizing: border-box;
      transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
    }

    .brand-logo-card:hover {
      transform: translateY(-2px);
      border-color: #CBD5E1;
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
    }

    .brand-logo-img {
      width: 100%;
      height: 100%;
      max-width: 90px;
      max-height: 48px;
      object-fit: contain;
      display: block;
      filter: contrast(1.02);
      pointer-events: none;
    }

    @media (max-width: 768px) {
      .brands-marquee-track {
        gap: 12px;
        animation-duration: 22s; /* Slightly faster cadence on smaller viewports */
      }
      .brand-logo-card {
        width: 104px;
        min-width: 104px;
        height: 68px;
        padding: 8px 12px;
      }
      .brand-logo-img {
        max-width: 78px;
        max-height: 40px;
      }
    }
  `}</style>

  <div style={styles.sectionHeaderRow}>
    <h3 style={styles.sectionTitle}>Our Trusted Brands</h3>
  </div>

  <div className="brands-marquee-viewport">
    <div className="brands-marquee-track">
      {/* Primary Set + Duplicate Set for seamless, gapless looping */}
      {[...POPULAR_BRANDS, ...POPULAR_BRANDS].map((brand, index) => (
        <div
          key={`${brand.id}-${index}`}
          className="brand-logo-card"
          onClick={() =>
            navigate(`/consumer/search?q=${encodeURIComponent(brand.name)}`)
          }
          title={brand.name}
        >
          <img
            src={brand.image}
            alt={brand.name}
            className="brand-logo-img"
            loading="lazy"
          />
        </div>
      ))}
    </div>
  </div>
</section>
            {/* 6. VIDEO TESTIMONIAL BANNER */}
          {/*   <div
              style={styles.testimonialBanner}
              onClick={() => window.open('https://brickbucket.in', '_blank')}
            >
              <div style={styles.playIconCircle}>
                <span style={styles.playIconText}>▶</span>
              </div>
              <div style={styles.testimonialTextCol}>
                <h4 style={styles.testimonialTitle}>Why Buyers Use Brickbucket</h4>
                <p style={styles.testimonialSubtext}>
                  Real stories from site supervisors and contractors
                </p>
              </div>
              <button style={styles.watchNowBtn}>Watch Now</button>
            </div> */}
          
          {/* 6. BUILDER TESTIMONIALS */}
            <BuilderTestimonials />
          </div>
        </CenteredContainer>
      </main>

      <Footer />

      {/* Slide-over Bucket Drawer */}
      <Bucket isOpen={isBucketOpen} onClose={() => setIsBucketOpen(false)} />
    </div>
  );
}

const styles = {
  pageShell: {
    backgroundColor: theme.colors.grey001,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: theme.typography.bodyMD.fontFamily,
    color: theme.colors.charcoal,
  },
  mainFeedShell: {
    width: '100%',
    padding: `${theme.spacing[300]}px 0 ${theme.spacing[600]}px 0`,
  },
  feedColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing[300],
  },
  heroRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: theme.spacing[200],
  },
  heroSlideCard: {
    backgroundColor: theme.colors.brandTint,
    borderRadius: theme.radius[16],
    border: `1px solid ${theme.colors.brandTint}`,
    padding: theme.spacing[200],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 140,
    boxSizing: 'border-box',
  },
  heroSlideAltCard: {
    backgroundColor: '#FEF3C7',
    borderRadius: theme.radius[16],
    border: '1px solid #FDE68A',
    padding: theme.spacing[200],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 140,
    boxSizing: 'border-box',
  },
  heroWhatsAppCard: {
    backgroundColor: '#ECFDF5',
    borderRadius: theme.radius[16],
    border: '1px solid #A7F3D0',
    padding: theme.spacing[200],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 140,
    boxSizing: 'border-box',
    cursor: 'pointer',
  },
  heroTextSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing[50],
  },
  heroTagline: {
    ...theme.typography.bodySM,
    color: theme.colors.bitumen,
  },
  heroHeading: {
    ...theme.typography.displayXL,
    fontSize: 26,
    lineHeight: '28px',
    color: theme.colors.bitumen,
    margin: 0,
  },
  heroHeadingAlt: {
    ...theme.typography.headingMD,
    fontSize: 16,
    lineHeight: '20px',
    color: theme.colors.bitumen,
    margin: 0,
  },
  heroSubtext: {
    ...theme.typography.bodySM,
    color: theme.colors.concrete,
  },
  heroSubtextAlt: {
    ...theme.typography.bodySM,
    fontSize: 11,
    lineHeight: '14px',
    color: theme.colors.bitumen,
    margin: 0,
  },
  heroLocationRow: {
    marginTop: theme.spacing[50],
    cursor: 'pointer',
  },
  heroLocationLink: {
    ...theme.typography.bodySM,
    fontSize: 11,
    color: theme.colors.brand,
    fontWeight: '600',
  },
  heroLocationLinkGreen: {
    ...theme.typography.bodySM,
    fontSize: 11,
    color: '#059669',
    fontWeight: '700',
  },
  urgencyBadge: {
    backgroundColor: theme.colors.brand,
    alignSelf: 'flex-start',
    padding: '2px 6px',
    borderRadius: theme.radius[8],
    marginBottom: 2,
  },
  urgencyBadgeText: {
    ...theme.typography.bodySM,
    fontSize: 9,
    color: theme.colors.pureWhite,
    fontWeight: '700',
  },
  whatsappBadge: {
    backgroundColor: '#059669',
    alignSelf: 'flex-start',
    padding: '2px 6px',
    borderRadius: theme.radius[8],
    marginBottom: 2,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  whatsappBadgeText: {
    ...theme.typography.bodySM,
    fontSize: 9,
    color: theme.colors.pureWhite,
    fontWeight: '700',
  },
  whatsappMiniSvg: {
    width: 10,
    height: 10,
    objectFit: 'contain',
  },
  truckIconPlaceholder: {
    width: 72,
    height: 72,
    borderRadius: theme.radius[12],
    backgroundColor: theme.colors.pureWhite,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...theme.shadows.fieldShadow,
    flexShrink: 0,
  },
  truckEmoji: {
    fontSize: 36,
  },
  clockIconPlaceholder: {
    width: 64,
    height: 64,
    borderRadius: 32,
    backgroundColor: theme.colors.pureWhite,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...theme.shadows.fieldShadow,
    flexShrink: 0,
  },
  clockEmoji: {
    fontSize: 30,
  },
  whatsappIconPlaceholder: {
    width: 64,
    height: 64,
    borderRadius: 32,
    backgroundColor: '#25D366',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...theme.shadows.fieldShadow,
    flexShrink: 0,
  },
  whatsappHeroSvg: {
    width: 32,
    height: 32,
    objectFit: 'contain',
  },
  sectionContainer: {
    marginBottom: theme.spacing[100],
  },
  sectionHeaderRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing[150],
  },
  sectionTitle: {
    ...theme.typography.headingMD,
    fontSize: 16,
    color: theme.colors.bitumen,
    margin: 0,
  },
  viewAllBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    cursor: 'pointer',
  },
  viewAllText: {
    ...theme.typography.bodySM,
    color: theme.colors.bitumen,
  },
  arrowIcon: {
    width: 12,
    height: 12,
    objectFit: 'contain',
  },
  arrowIcon14: {
    width: 14,
    height: 14,
    objectFit: 'contain',
  },
  categoriesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(124px, 1fr))',
    columnGap: `${theme.spacing[200]}px`,
    rowGap: `${theme.spacing[300]}px`,
    width: '100%',
    alignItems: 'start',
  },
  categoryItemCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'transform 0.18s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  categoryImgBox: {
    width: '100%',
    maxWidth: 120,
    height: 120,
    backgroundColor: '#F4F5F7',
    borderRadius: theme.radius[16],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${theme.spacing[100]}px`,
    boxSizing: 'border-box',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
  },
  categoryImg: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    borderRadius: theme.radius[8],
    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.06))',
  },
  categoryFallbackBox: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: theme.radius[12],
  },
  toteIcon28: {
    width: 40,
    height: 40,
    opacity: 0.35,
  },
  categoryItemName: {
    marginTop: 8,
    fontSize: 13.5,
    lineHeight: '17px',
    fontFamily: theme.typography.headingMD.fontFamily,
    fontWeight: '700',
    color: theme.colors.bitumen || '#2B2A29',
    textAlign: 'center',
    width: '100%',
    maxWidth: 120,
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'break-word',
  },
  discountsRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: theme.spacing[150],
  },
  discountCard: {
    borderRadius: theme.radius[12],
    borderWidth: 1,
    borderStyle: 'solid',
    padding: theme.spacing[150],
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing[100],
    cursor: 'pointer',
    boxSizing: 'border-box',
  },
  couponCardBg: {
    backgroundColor: theme.colors.brandTint,
    borderColor: theme.colors.brandTint,
  },
  referralCardBg: {
    backgroundColor: '#ECFDF5',
    borderColor: '#A7F3D0',
  },
  discountIconBadgeRed: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: theme.colors.brand,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  },
  percentText: {
    ...theme.typography.headingMD,
    fontSize: 16,
    color: theme.colors.pureWhite,
    fontWeight: '700',
  },
  discountIconBadgeGreen: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: theme.colors.pureWhite,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  },
  referralIconText: {
    fontSize: 16,
  },
  discountCardTextGroup: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 5,
  },
  couponCodeTitle: {
    ...theme.typography.monoMD,
    fontSize: 13,
    color: theme.colors.brand,
    fontWeight: '700',
    marginBottom: 2,
  },
  referralTitle: {
    ...theme.typography.bodyLG,
    fontSize: 13,
    color: theme.colors.success,
    fontWeight: '700',
  },
  discountDesc: {
    ...theme.typography.bodySM,
    fontSize: 12,
    color: theme.colors.bitumen,
    lineHeight: '14px',
  },
  discountMinOrder: {
    ...theme.typography.bodySM,
    fontSize: 10,
    color: theme.colors.concrete,
    marginTop: 2,
  },
  productsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))',
    gap: theme.spacing[100],
  },
  productCard: {
    backgroundColor: theme.colors.pureWhite,
    borderRadius: theme.radius[12],
    border: `0.5px solid ${theme.colors.grey002}`,
    overflow: 'hidden',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
  },
recentImage: {
    width: '100%',
    height: 80,
    backgroundColor: '#FFFFFF',
    objectFit: 'contain',
    margin: '6px 0',
    display: 'block',
  },
  recentImageFallback: {
    width: '100%',
    height: 80,
    backgroundColor: '#FFFFFF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '6px 0',
  },
  productCardBody: {
    padding: '8px 10px 10px 10px',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  productName: {
    fontSize: 12,
    lineHeight: '15px',
    color: '#2B2A29',
    fontWeight: '600',
    height: 30,
    margin: 0,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  priceRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 5,
    marginTop: 2,
  },
  productPrice: {
    fontSize: 13,
    color: '#2B2A29',
    fontWeight: '700',
  },
  productMrp: {
    fontSize: 10.5,
    color: '#707B8C',
    textDecoration: 'line-through',
  },

  // 6. Popular Brands Styles matching React Native exactly
  brandsHorizontalList: {
    display: 'flex',
    alignItems: 'center',
    gap: `${theme.spacing[100]}px`,
    overflowX: 'auto',
    paddingBottom: 4,
    width: '100%',
    scrollbarWidth: 'none', // Standard clean web scroll
  },
  brandLogoCard: {
    width: 90,
    minWidth: 90,
    height: 52,
    borderRadius: theme.radius[8],
    borderWidth: 0.5,
    borderStyle: 'solid',
    borderColor: theme.colors.grey002,
    backgroundColor: theme.colors.pureWhite,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    cursor: 'pointer',
    boxSizing: 'border-box',
    flexShrink: 0,
    transition: 'transform 0.15s ease, border-color 0.15s ease',
  },
  brandInnerBox: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 4,
    boxSizing: 'border-box',
  },
  brandImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    display: 'block',
  },

  testimonialBanner: {
    backgroundColor: theme.colors.brandTint,
    borderRadius: theme.radius[16],
    border: `1px solid ${theme.colors.brandTint}`,
    padding: theme.spacing[150],
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing[100],
    cursor: 'pointer',
    boxSizing: 'border-box',
  },
  playIconCircle: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: theme.colors.brand,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  },
  playIconText: {
    fontSize: 14,
    color: theme.colors.pureWhite,
    marginLeft: 2,
  },
  testimonialTextCol: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  testimonialTitle: {
    ...theme.typography.headingMD,
    fontSize: 13,
    color: theme.colors.bitumen,
    margin: 0,
  },
  testimonialSubtext: {
    ...theme.typography.bodySM,
    fontSize: 10,
    color: theme.colors.concrete,
    margin: 0,
  },
  watchNowBtn: {
    backgroundColor: theme.colors.brand,
    padding: '6px 14px',
    borderRadius: theme.radius[8],
    border: 'none',
    color: theme.colors.pureWhite,
    ...theme.typography.buttonSM,
    fontSize: 11,
    cursor: 'pointer',
    flexShrink: 0,
  },
  stateContainer: {
    padding: theme.spacing[300],
    textAlign: 'center',
    color: theme.colors.concrete,
    ...theme.typography.bodySM,
  },
  errorText: {
    color: theme.colors.error,
    ...theme.typography.bodySM,
    padding: theme.spacing[200],
    textAlign: 'center',
  },
};